import { render, staticRenderFns } from "./ReminderTable.vue?vue&type=template&id=68b1a92e&scoped=true&"
import script from "./ReminderTable.vue?vue&type=script&lang=js&"
export * from "./ReminderTable.vue?vue&type=script&lang=js&"
import style0 from "./ReminderTable.vue?vue&type=style&index=0&id=68b1a92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1a92e",
  null
  
)

export default component.exports